/**
 * Javascript initiation script
 *
 * @package Wordpress/imhof-digital
 * @since 20191230 Version 5.0.3
 */

if( !window.idscript || window.idscript === 'undefined' ) {

   window.idscript = {};

}

var idscript = window.idscript;
